import { defineMessages } from 'react-intl';

export const estimationItemsGroupedTablesMessageDefinitions = defineMessages({
  estimationUnit: {
    id: 'estimationDetail.estimationItemsGrouped.estimationUnit',
    defaultMessage: 'Estimation Unit',
  },
});
